import * as React from "react";
import { Link } from "gatsby";
import logoImg from "../images/Logo-horizontal-gradgrey.svg";
import useFooter from "../hooks/useFooter";

const FooterMini = () => {

  const { legal } = useFooter();
  
  //console.log(legal)
 
  return (
    <footer className="py-6 px-6 bg-[#FFFFFF14]">
      <div className="flex flex-col lg:flex-row justify-center gap-4 lg:gap-x-12">
        <div>
        <Link to="/" className="">
          <img
            src={logoImg}
            alt="sightfull"
            className="inline"
            loading="lazy"
          />
        </Link>
        </div>
        <div className="space-y-1 lg:space-x-6">
          { legal.map((item , index) => (
            <Link key={index} to={item.url} className="text-[#8897AE] hover:text-white block lg:inline">
              {item.label}
            </Link>
          ))}
        </div>
      </div>
     
    </footer>
  );
};

export default FooterMini;
